/**
 * propertyConditionAtOrigination
 *
 * { value, label } pairs — `value` is the stored code (C1–C6 / TBD), `label`
 * is the human-readable condition description shown in selects. SelectInput
 * (and the Rff* fields built on it) render `label` for the chosen value and
 * in the dropdown, so the long descriptions surface wherever this is used.
 */
export const selectOptionsPropertyConditionAtOrigination = [
  {
    value: "C1",
    label: "C1 — New construction / never occupied; all materials new",
  },
  {
    value: "C2",
    label: "C2 — No deferred maintenance; recent updates, like-new",
  },
  {
    value: "C3",
    label: "C3 — Well-maintained, some minor wear; functional and clean",
  },
  {
    value: "C4",
    label:
      "C4 — Adequately maintained; minor deferred maintenance/cosmetic wear",
  },
  {
    value: "C5",
    label:
      "C5 — Obvious deferred maintenance; livable but worn; renovations needed",
  },
  {
    value: "C6",
    label:
      "C6 — Substantial damage / not safely habitable; major repairs required",
  },
  { value: "TBD", label: "TBD" },
];
